<template>
  <div class="feature-videos">
    <div class="container">
      <component-video></component-video>
    </div>
  </div>
</template>

<script>
import Videos from "@/components/videos.vue";
export default {
  name: "videoFeatures",
  components: {
    "component-video": Videos
  }
};
</script>

<style lang="scss" scoped>
.feature-videos {
  padding: 20px 10px;
  background: rgb(251, 251, 253);
  min-height: 200px;
  .container {
    padding: 0;
  }
}
</style>
